import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_PRIDE_LOGO = createFcmConfig('enable_pride_logo', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
